/**
 * 数据中心 → 配料机数据 → 多机互联（薄封装 teaEarlyBrew 工作台）
 * parent = coffee_menu XTSeriesData 1776875108514795520
 * 注：不可用 990422（已占用 ecosystemMallCatalog）
 */
export const DISPENSER_MULTI_MACHINE_MENU_IDS = {
  page: 991134,
  enName: 'dispenserMultiMachine',
  parentEnName: 'XTSeriesData',
  parentId: 1776875108514795520
}



// WEBPACK FOOTER //
// ./src/constants/dispenserMultiMachine.js